/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_ReligionInputs */

const en_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religion`)
};

const fr_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religion`)
};

const de_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religion`)
};

const it_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religione`)
};

const ru_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Религия`)
};

const es_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religión`)
};

const zh_cn2_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宗教`)
};

const ja_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宗教`)
};

const hi_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`धर्म`)
};

const pt_pt2_subtitle_export_keyword_religion = /** @type {(inputs: Subtitle_Export_Keyword_ReligionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religião`)
};

/**
* | output |
* | --- |
* | "Religion" |
*
* @param {Subtitle_Export_Keyword_ReligionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_religion = /** @type {((inputs?: Subtitle_Export_Keyword_ReligionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_ReligionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_keyword_religion(inputs)
	if (locale === "de") return de_subtitle_export_keyword_religion(inputs)
	if (locale === "it") return it_subtitle_export_keyword_religion(inputs)
	if (locale === "ru") return ru_subtitle_export_keyword_religion(inputs)
	if (locale === "es") return es_subtitle_export_keyword_religion(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_keyword_religion(inputs)
	if (locale === "ja") return ja_subtitle_export_keyword_religion(inputs)
	if (locale === "hi") return hi_subtitle_export_keyword_religion(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_keyword_religion(inputs)
	return en_subtitle_export_keyword_religion(inputs)
});